<template>
  <div class="dashboard_container">
    <Navbar></Navbar>
    <div class="dashboard_content">
        <MyCourses></MyCourses>
    </div>
  </div>
</template>

<script>
import Navbar from '../../views/Navbar'
// import MyCourses from './Courses/MyCourses'
import MyCourses from '../../views/Home'
export default {
  components: {
    Navbar,
    MyCourses
  }
}
</script>

<style>
.dashboard_container{
  height: 100%;
}
.dashboard_content{
  padding-top: 64px;
}
</style>
